import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar/sidebar";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import Loader from "../../components/loader/loader";
import {
  deleteData,
  getListData,
  updateData,
  createData,
  useDebounce,
} from "../../hooks/api/utils";
import CommonModal from "../../components/modal/modal";

const baseURL = process.env.REACT_APP_API_URL;

const Users = () => {
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [isActive, setIsActive] = useState("");
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500, setPage);
  const pageCount = Math.ceil((userList?.count || 0) / pageSize);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [errors, setErrors] = useState({ amount: "", description: "" });

  const [walletData, setWalletData] = useState({
    amount: "",
    description: "",
  });

  const fetchUsers = async () => {
    await getListData(
      "/admin-panel/users-list/",
      setLoading,
      setUserList,
      page,
      pageSize,
      `&is_active=${isActive}&search=${search}`
    );
  };

  useEffect(() => {
    fetchUsers();
  }, [debouncedSearch, isActive, page]);

  const handlePageClick = (p) => setPage(p);

  const handleToggleStatus = async (user) => {
    await updateData(
      "/admin-panel/block-user/",
      user?.id,
      setLoading,
      {},
      () => {},
      ""
    );
    fetchUsers();
  };

  const confirmDelete = async () => {
    if (!selectedUserId) return;
    await updateData(
      "/admin-panel/delete-user/",
      selectedUserId,
      setLoading,
      {},
      () => {},
      ""
    );
    setSelectedUserId(null);
    setIsDeleteModalOpen(false);
    setPage(1);
    fetchUsers();
  };

  const handleWalletSubmit = async () => {
    let newErrors = { amount: "", description: "" };
    let isValid = true;

    if (!walletData.amount || Number(walletData.amount) <= 0) {
      newErrors.amount = "Amount must be greater than 0";
      isValid = false;
    }

    if (!walletData.description.trim()) {
      newErrors.description = "Description is required";
      isValid = false;
    }

    setErrors(newErrors);

    if (!isValid) return; // stop if validation fails

    if (!selectedUserId) return;

    const body = {
      amount: Number(walletData.amount),
      description: walletData.description.trim(),
    };

    await createData(
      `/admin-panel/add-wallet-amount/?uid=${selectedUserId}`,
      setLoading,
      body,
      () => {}, // no redirect navigation
      "" // no redirect path
    );

    setWalletData({ amount: "", description: "" });
    setErrors({ amount: "", description: "" });
    setSelectedUserId(null);
    setIsWalletModalOpen(false);
    fetchUsers();
  };

  return (
 <>
      <div className="rightContent">
        <div className="viewMain">
          <div className="row">
            <div className="col-md-12 bg-white left-col p-2">
              <div className="sortSearchArea search-margin mt-0 p-4 justify-content-between">
                <h4>Users</h4>
                <div className="d-flex align-items-center gap-4 width-75 justify-content-end flex-wrap">
                  <div className="user-filtering width-25">
                    <select
                      className="form-control selectwidth"
                      defaultValue={isActive}
                      onChange={(e) => setIsActive(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="true">Active</option>
                      <option value="false">Blocked</option>
                    </select>
                  </div>

                  <div className="search">
                    <input
                      type="search"
                      placeholder="Search"
                      className="search-input"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span
                      style={{ background: "none", border: "none", padding: 0 }}
                    >
                      <img
                        src="../images/search-dark.svg"
                        className="img-fluid"
                        alt="Search"
                      />
                    </span>
                  </div>
                  <button
                    className="btn btn-outline-secondary p-3 width-25"
                    onClick={() => {
                      const downloadUrl =
                        `${baseURL}/admin-panel/export-users`;
                      const link = document.createElement("a");
                      link.href = downloadUrl;
                      link.setAttribute("download", "users.xlsx");
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                    }}
                  >
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                        width={20}
                        height={20}
                      >
                        <path d="M352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 306.7L246.6 265.3C234.1 252.8 213.8 252.8 201.3 265.3C188.8 277.8 188.8 298.1 201.3 310.6L297.3 406.6C309.8 419.1 330.1 419.1 342.6 406.6L438.6 310.6C451.1 298.1 451.1 277.8 438.6 265.3C426.1 252.8 405.8 252.8 393.3 265.3L352 306.7L352 96zM160 384C124.7 384 96 412.7 96 448L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 448C544 412.7 515.3 384 480 384L433.1 384L376.5 440.6C345.3 471.8 294.6 471.8 263.4 440.6L206.9 384L160 384zM464 440C477.3 440 488 450.7 488 464C488 477.3 477.3 488 464 488C450.7 488 440 477.3 440 464C440 450.7 450.7 440 464 440z" />
                      </svg>
                    </span>{" "}
                    Download Users
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="pateintData">
                    <div className="treatmentData tableTransactionData table-responsive">
                      <table className="table equal-spacing-table">
                        <thead className="tableTransactionHead">
                          <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody className="tableData-color">
                          {loading ? (
                            <Loader />
                          ) : userList?.results?.length > 0 ? (
                            userList.results.map((user, idx) => (
                              <tr key={idx}>
                                <td>{user?.id  || "--"}</td>
                                <td>{user?.full_name || "--"}</td>
                                <td className="main-grey-text">
                                  {user?.email}
                                </td>
                                <td
                                  className={
                                    user?.status === "Active"
                                      ? "text-green"
                                      : "main-grey-text"
                                  }
                                >
                                  {user?.status}
                                </td>
                                <td>
                                 <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-3 action-buttons">

                                    {user?.status === "Active" ? (
                                      <img
                                        src="images/blockicon.svg"
                                        width="20"
                                        className="img-fluid"
                                        alt="block"
                                        title="Block"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleToggleStatus(user)}
                                      />
                                    ) : (
                                      <img
                                        src="images/unblockIcon.svg"
                                        width="20"
                                        className="img-fluid"
                                        alt="unblock"
                                        title="Unblock"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleToggleStatus(user)}
                                      />
                                    )}
                                    <button
                                      className="bg-transparent border-0"
                                      onClick={() => {
                                        setSelectedUserId(user?.id);
                                        setSelectedUserName(user?.full_name);
                                        setIsDeleteModalOpen(true);
                                      }}
                                    >
                                      <img
                                        src="images/deleteGreyIcon.svg"
                                        width="20"
                                        className="img-fluid"
                                        alt="delete"
                                        title="Delete"
                                      />
                                    </button>
                                    <button
                                      className="bg-transparent border-0"
                                      onClick={() => {
                                        setSelectedUserId(user?.id);
                                        setIsWalletModalOpen(true);
                                      }}
                                    >
                                      <img
                                        src="images/wallet-amount.svg"
                                        width="20"
                                        className="img-fluid"
                                        alt="wallet amount"
                                        title="Wallet Amount"
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4">No users found.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <ResponsivePagination
                    className="pagination justify-content-center mt-5"
                    current={page}
                    total={pageCount}
                    onPageChange={handlePageClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <CommonModal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => {
          setSelectedUserId(null);
          setSelectedUserName("");
          setIsDeleteModalOpen(false);
        }}
        title="Confirm Delete"
      >
        <p className="text-center mb-4">
          Are you sure you want to delete <b>{selectedUserName}</b>?
        </p>
        <div className="d-flex justify-content-end gap-3">
          <button
            className="transparent_btn"
            onClick={() => {
              setSelectedUserId(null);
              setSelectedUserName("");
              setIsDeleteModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button className="red_btn" onClick={confirmDelete}>
            Confirm
          </button>
        </div>
      </CommonModal>

      {/* Wallet Modal */}
      <CommonModal
        isOpen={isWalletModalOpen}
        onRequestClose={() => {
          setSelectedUserId(null);
          setIsWalletModalOpen(false);
          setWalletData({ amount: "", description: "" });
          setErrors({ amount: "", description: "" });
        }}
        title="Add Wallet Amount"
      >
        <div className="mb-3">
          <label className="form-label">Amount</label>
          <input
            type="number"
            className={`form-control ${errors.amount ? "is-invalid" : ""}`}
            value={walletData.amount}
            onChange={(e) =>
              setWalletData({ ...walletData, amount: e.target.value })
            }
          />
          {errors.amount && (
            <div className="invalid-feedback">{errors.amount}</div>
          )}
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            className={`form-control ${errors.description ? "is-invalid" : ""}`}
            value={walletData.description}
            onChange={(e) =>
              setWalletData({ ...walletData, description: e.target.value })
            }
          />
          {errors.description && (
            <div className="invalid-feedback">{errors.description}</div>
          )}
        </div>
        <div className="d-flex justify-content-end gap-3">
          <button
            className="transparent_btn"
            onClick={() => {
              setSelectedUserId(null);
              // setSelectedUserName("");
              setIsWalletModalOpen(false);
              setWalletData({ amount: "", description: "" });
              setErrors({ amount: "", description: "" });
            }}
          >
            Cancel
          </button>
          <button className="blue_btn" onClick={handleWalletSubmit}>
            Add
          </button>
        </div>
      </CommonModal>
    </>
  );
};

export default Users;
